/* eslint-disable no-undef */
import React, {
    useContext, useEffect, useState
} from 'react';
import {
    Context
} from 'shared/context/GlobalState';
import {
    httpRequest
} from 'shared/utils/httpsRequest';
import {
    AppLoader
} from 'shared/components/LoaderSpinner';
import NewStyledTable from 'shared/components/ui/StyledTable';
import {
    MdDelete, MdEdit, MdSettings
} from 'react-icons/md';
import AlertModal from 'shared/components/Alertmodal';
import {
    Link, useParams, useNavigate
} from 'react-router-dom';
import CreateSubOrganizationDialog from 'shared/components/AddSubOrgForm';
import UpdateSubOrganizationDialog from 'shared/components/UpdateSubOrganizationDialog';
import {
    OrganizationContext
} from 'shared/context/OrganizationContext';

function SubOrganizations() {
    const [tableData, setTableData] = useState([]);
    const [openUpdateModal, setOpenUpdateModal] = useState(false);
    const [alertModal, setAlertModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [btnLoading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const {
        addNewNotifcation, user
    } = useContext(Context);
    const {
        selectedOrganization, getUserRole
    } = useContext(OrganizationContext);
    const {
        oragID
    } = useParams();
    const navigate = useNavigate();
    const roleInstance = getUserRole();

    useEffect(() => {
        setTableData(selectedOrganization?.subOrganizations.map(item => ({
            ...item,
            id: item._id
        })));
        setLoading(false);
    }, [selectedOrganization]);

    const handleDelete = (itemId) => {
        if (roleInstance.isSuperAdmin) {
            setAlertModal(true);
            const data = tableData.find((item) => item.id === itemId);
            setSelectedItem(data);
        }
        else {
            addNewNotifcation('Sorry, you are not authorized to delete sub-organization', 'warning');
        }
    };

    const handleUpdate = (itemId) => {
        if (roleInstance.isSuperAdmin || roleInstance.isAdmin) {
            setOpenUpdateModal(true);
            const data = tableData.find((item) => item.id === itemId);
            setSelectedItem(data);
        } else {
            addNewNotifcation('Sorry, you are not authorized to update sub-organization', 'warning');
        }
    };

    const handleOnDelete = () => {
        setBtnLoading(true);
        const deleteObj = {
            subOrganizationId: selectedItem._id,
            organizationId: oragID
        };
        httpRequest.delete('/db/sub-organizations/delete-sub-organization', {
            data: deleteObj
        })
            .then(() => {

                addNewNotifcation('Sub-organization deleted successfully', 'success');
                setTimeout(() => {
                    window.location = `/organizations/${oragID}/sub`;
                }, 1500);
            })
            .catch(() => {

                addNewNotifcation('Sub-organization could not be deleted', 'danger');
            })
            .finally(() => {
                setBtnLoading(false);
                setAlertModal(false);
            });
    };

    const handleSettings = (itemId) => {
        localStorage.setItem('selectedSubOrg', itemId);
        navigate(`${itemId}/settings`);
    };

    const handleAddNewSubOrg = () => {
        if (!roleInstance.isSuperAdmin) {
            addNewNotifcation('Sorry, you are not authorized to add sub-organization', 'warning');
        } else {
            setShow(true);
        }
    };

    const subOrgRowActions = [
        {
            name: 'Edit',
            icon: <MdEdit size={18} />,
            onclick: handleUpdate
        },
        {
            name: 'Settings',
            icon: <MdSettings size={18} />,
            onclick: handleSettings
        },
        {
            name: 'Remove',
            icon: <MdDelete size={18} color='var(--primary-color)' />,
            onclick: handleDelete,
            isDelete: true
        },
    ];

    const subOrgTableActions = [
        // {'name': 'Delete Selected', 'icon': <MdDelete size={18} color='var(--primary-color)' />, 'onclick': handleDeleteSelected},
        {
            name: 'Add New',
            icon: <MdDelete size={18} color='var(--primary-color)' />,
            onclick: handleAddNewSubOrg
        }
    ];

    const handleSubOrgUpdated = (subOrgId, members) => {
        setTableData((prev) => prev.map((row) => (
            (row.id === subOrgId || row._id === subOrgId)
                ? { ...row, members: Array.isArray(members) ? members : [] }
                : row
        )));
    };

    const getMemberCount = (rowData) => {
        if (rowData.isMain) return organizationMembersWithSuperAdmin;
        return Array.isArray(rowData.members) ? rowData.members.length : 0;
    };

    const organizationMembersWithSuperAdmin = selectedOrganization.members.length + 1;

    return (
        <div className='flex p-8 overflow-y-scroll w-full min-w-[700px]'>
            <div className="w-full">
                <div className='py-4 h-auto'>
                    {loading ? (
                        <AppLoader />
                    ) : (
                        <NewStyledTable
                            cardTitle={`Sub Organizations (${tableData.length})`}
                            columns={[
                                {
                                    field: 'name',
                                    headerName: 'Name',
                                    renderCell: (rowData) => (
                                        <div onClick={() => localStorage.setItem('selectedSubOrg', rowData.id)}>
                                            <Link className='flex items-center gap-2 text-[blue] hover:underline' to={`${rowData.id}/de-studio`}>
                                                {rowData.name}
                                            </Link>
                                        </div>
                                    )
                                },
                                {
                                    field: 'members',
                                    headerName: 'Members',
                                    renderCell: (rowData) => getMemberCount(rowData)
                                }
                            ]}
                            data={tableData}
                            rowActions={subOrgRowActions}
                            tableActions={subOrgTableActions}
                        // multiSelect={true}
                        />
                    )}
                    <CreateSubOrganizationDialog show={show} setShow={setShow} addNewNotifcation={addNewNotifcation} />

                    <UpdateSubOrganizationDialog
                        show={openUpdateModal}
                        setShow={setOpenUpdateModal}
                        subOrg={selectedItem}
                        setSubOrg={setSelectedItem}
                        user={user}
                        addNewNotification={addNewNotifcation}
                        onSubOrgUpdated={handleSubOrgUpdated}
                    />

                    <AlertModal
                        loading={btnLoading}
                        setopenModal={setAlertModal}
                        openModal={alertModal}
                        onDelete={handleOnDelete}
                    />
                </div>
            </div>
        </div>
    );
}

export default SubOrganizations;